<template>
  <div class="metronome">
    <div>
      <span>音を出す<br>リズムを<br>選択できます</span>
    </div>
    <div @click.capture="isRhythmChange">
      <img src="../../../assets/rhythm.png" width="40" height="40" :class="{'disabled':!madeRhythm}" />
      <span>打ち込んだリズムを<br>再生する</span>
    </div>
    <div @click.capture="isMetronomeChange">
      <img src="../../../assets/met.png" width="40" height="40" :class="{'disabled':!metronome}" />
      <span>メトロノームを<br>再生する</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'metronome',
  props: {
    metronome: {type: Boolean, required: true},
    madeRhythm: {type: Boolean, required: true}
  },
  methods: {
    isRhythmChange: function(){
      this.$emit('isRhythmChange', !this.madeRhythm);
    },
    isMetronomeChange: function(){
      this.$emit('isMetronomeChange', !this.metronome);
    },
  }
}
</script>

<style scoped>
.metronome{
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
}
.metronome div{
  width: 33%;
}
.metronome div:nth-child(1){
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  align-items: center;
  color: #555;
  
}
.metronome div:nth-child(2),
.metronome div:nth-child(3){
  display: block;
  font-size: 0.65rem;
  margin: 0 auto;
  padding: 8px 0;
  color: #333;
}
.metronome div:nth-child(2) img,
.metronome div:nth-child(3) img{
  display: block;
  margin: 0 auto;
}
.metronome div:nth-child(2) img.disabled,
.metronome div:nth-child(3) img.disabled{
  opacity: 0.5;
}

.toggle-wraper{
  display: block;
  position: relative;
  margin: 0 auto;
  padding: 0;
}
</style>
